/**
 * Kamus terjemahan.
 *
 * Dulu keempat bahasa ditulis dalam satu berkas ini. Bentuk itu menyembunyikan
 * masalahnya: Melayu dan Arab cuma punya 69 dari 213 kunci, dan sisanya jatuh
 * diam-diam ke Indonesia lewat rantai `?? dict.id[key]` di I18nProvider. Jadi
 * pengunjung yang memilih Melayu mendapat halaman separuh Indonesia, dan tidak
 * ada satu pun yang gagal — tidak ada peringatan, tidak ada layar merah.
 *
 * Sekarang tiap bahasa punya berkasnya sendiri di locales/, dan kelengkapannya
 * DIPERIKSA: lihat `npm run i18n:check` (scripts/i18n-check.mjs) yang dijalankan
 * di CI, plus peringatan konsol saat pengembangan di bawah.
 *
 * id = sumber kebenaran. Kunci yang ada di id WAJIB ada di ketiga bahasa lain.
 */
import id from './locales/id'
import en from './locales/en'
import ms from './locales/ms'
import ar from './locales/ar'

export const LOCALES = [
  { code: 'id', label: 'Bahasa Indonesia', short: 'ID', dir: 'ltr' },
  { code: 'en', label: 'English', short: 'EN', dir: 'ltr' },
  { code: 'ms', label: 'Bahasa Melayu', short: 'MS', dir: 'ltr' },
  { code: 'ar', label: 'العربية', short: 'AR', dir: 'rtl' },
]

export const dict = { id, en, ms, ar }

// Peringatan saat pengembangan. Sengaja hanya di dev: di produksi ini tidak
// menolong siapa pun, dan menjalankan diff di tiap boot itu sia-sia.
if (import.meta.env?.DEV) {
  const base = Object.keys(id)
  for (const code of ['en', 'ms', 'ar']) {
    const missing = base.filter((k) => !(k in dict[code]))
    if (missing.length) {
      console.warn(
        `[i18n] "${code}" kekurangan ${missing.length} kunci dan akan jatuh ke bahasa Indonesia:`,
        missing.slice(0, 12).join(', ') + (missing.length > 12 ? ', …' : ''),
      )
    }
  }
}
